import React, { useState } from "react";
import { Page } from "shared/ui";
import { Dayjs } from "dayjs";
import PlannerViewTable from "./ui/PlannerViewTable";

const PlannerViewPage = () => {
  const [filters, setFilters] = useState<{
    process?: string[];
    status?: string;
    dateRange: [Dayjs | null, Dayjs | null];
  }>({
    process: undefined,
    status: undefined,
    dateRange: [null, null],
  });

  const handleClearAllFilters = () => {
    setFilters({
      process: undefined,
      status: undefined,
      dateRange: [null, null],
    });
  };

  const isActive =
    Boolean(filters.process) ||
    Boolean(filters.status) ||
    Boolean(filters.dateRange[0] && filters.dateRange[1]);

  return (
    <Page
      title="Planner View"
      isVisibleClearFiltersButton={isActive}
      clearAllFilters={handleClearAllFilters}
    >
      <PlannerViewTable filters={filters} setFilters={setFilters} />
    </Page>
  );
};

export { PlannerViewPage };
